import { jsx as _jsx } from "react/jsx-runtime";
import { withStoreProvider, useStore } from '../store/storeProvier';
import Node from '../node';
import { createStore } from '../store/createStore';
import Impression from '../impression';
import Loading from '../loading';

var Iframe = function Iframe(props) {
  var _ref = props.config || {},
      _ref$dynamic = _ref.dynamic,
      dynamic = _ref$dynamic === void 0 ? true : _ref$dynamic,
      _height = _ref.height,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? "default" : _ref$loading;

  var rootConfig = useStore(function (store) {
    var _a;

    return (_a = store['root']) === null || _a === void 0 ? void 0 : _a.config;
  });
  return _jsx(Impression, Object.assign({}, props, {
    offset: 200,
    dynamic: dynamic,
    height: function height() {
      return _height;
    }
  }, {
    children: rootConfig ? _jsx(Node, {
      id: "root"
    }) : _jsx(Loading, {
      type: loading
    })
  }));
};

Iframe.displayName = 'Iframe';
export default withStoreProvider(createStore)(Iframe);